import { h, render, Component } from 'preact';
import './style';
import App from './components/app';
import {getUrlParams} from './components/helper';

const url = new URL(document.currentScript.src);
__webpack_public_path__ = (url.origin + __webpack_public_path__);

// For Display AdUnit script tag we fetch the required parameters through div tag instead of meta---
const displayAdunitScript = document.querySelector('.wt-display-adunit');
const displayAd = displayAdunitScript && displayAdunitScript.getAttribute('data-adunit');
const displayAdData = {};
if (displayAd) {
  let temp = displayAd.split("'").join("");
  temp = temp.split(';');
  let displayGUID = temp.find(item => item.indexOf('guid:') !== -1);
  displayAdData.guid = displayGUID.split(':')[1];
  let displayBucketName = temp.find(item => item.indexOf('bucket_name:') !== -1);
  displayAdData.bucketName = displayBucketName.split(':')[1];
  let displayDirectTag = temp.find(item => item.indexOf('direct_tag:') !== -1);
  displayAdData.displayDirectTag = displayDirectTag.split(':')[1];
  let displayForceStart = temp.find(item => item.indexOf('force_start:') !== -1);
  displayAdData.forceStart = displayForceStart.split(':')[1];
  let displayImpTrackers = temp.filter(item => item.indexOf('impression_tracker:') !== -1);
  displayAdData.displayImpTrackers = displayImpTrackers.map(item => ({ content: item.split('impression_tracker:')[1] }));
}

// Getting the bucketId and videoId from the meta tags, required since project level player implementation---
const metaGUID = document.querySelector("meta[name='wootag:guid']");
const wtGUID = metaGUID && metaGUID.getAttribute('content') || displayAdData.guid;
const metaBucketName = document.querySelector("meta[name='wootag:bucket_name']");
const wtBucketName = metaBucketName && metaBucketName.getAttribute('content') || displayAdData.bucketName;
const metaForceStart = document.querySelector("meta[name='wootag:force_start']");
const forceStart = metaForceStart && metaForceStart.getAttribute('content') || displayAdData.forceStart;

const clickThroughLink = document.querySelectorAll('meta[name="wootag:click_through"]');

//FOR TTD DISPLAY MACRO---
const metaMacroLink = document.querySelectorAll('meta[name="wootag:macro_tracker"]');
//---
export default class WootagPlayer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let bucketId = wtBucketName || this.props.bucketId;
    let videoId = wtGUID || this.props.videoId;

    let wootagDiv = document.getElementsByClassName('Wootag');
    let script = wootagDiv && wootagDiv[0] && wootagDiv[0].nextElementSibling;
    let type;
    let videoString;
    let isProject = false;
    let networkData;
    if (wootagDiv.length > 0 && wootagDiv !== null) {
      type = wootagDiv[0].getAttribute('data-af');
      videoString = wootagDiv[0].getAttribute('data-id');
      isProject = !!wootagDiv[0].getAttribute('data-project');
      networkData = wootagDiv[0].getAttribute('data-pr');
    }

    let clickThroughArray = [];
    clickThroughLink && clickThroughLink.forEach(item => clickThroughArray.push(item.content));
    clickThroughArray = (window.clickTag && [window.clickTag]) || clickThroughArray;
    // console.log(clickThroughArray);
    //FOR TTD DISPLAY MACRO---
    const macroParams = metaMacroLink && metaMacroLink[0] && metaMacroLink[0].content && getUrlParams(metaMacroLink[0].content);
    //---
    return (
      <App pluggedIn={true}
           video={this.props.video}
           bucketId={bucketId}
           videoId={videoId}
           forceStart={forceStart === 'true'}
           type={type}
           networkData={networkData}
           videoString={videoString}
           mraidTarget={script && script.src}
           json={this.props.json}
           isProject={isProject}
           displayDirectTag={displayAdData.displayDirectTag}
           displayImpTrackers={displayAdData.displayImpTrackers}
           displayAdClickThroughLink={clickThroughArray}
           macroParams={macroParams}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./index.js